import { request } from '@/utils/request';

/**
 * 权限相关
 */

export const _querySourceAuth = (
  params?: { authSource: string; gameCode?: string; queryRole?: boolean; typeCls: string[] },
  payload?: Request.IPayload
) => {
  return request('/apollo/authCenter/querySourceAuth', params, payload);
};
